import axios, { AxiosResponse } from 'axios'

import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'

interface LoginResponse {
  data: {
    wceiLogin: {
      auth_token: string | null
      rlp_dashboard_token: string | null
      rlp_certification_token: string | null
      registration_id: string | null
      incomplete_registration_count: number
      customer: {
        first_name: string
        last_name: string
        id: number
      }
    }
  }
  errors?: [{ message: string }]
}

export const loginMutation = gql`
  mutation wceiLogin($email: String!, $password: String!) {
    wceiLogin(input: { email: $email, password: $password }) {
      auth_token
      rlp_dashboard_token
      rlp_certification_token
      registration_id
      incomplete_registration_count
      customer {
        first_name
        id
        last_name
      }
    }
  }
`

const processLoginResponse = (data: LoginResponse): void => {
  if (data.errors) {
    throw data.errors[0].message
  }

  if (data.data.wceiLogin.auth_token) {
    // 2 hours from the current time
    const expirationTime = new Date(Date.now() + 7200 * 1000).toUTCString()

    const userSession = {
      token: data.data.wceiLogin.auth_token,
      expiration: expirationTime,
    }

    localStorage.setItem('authToken', JSON.stringify(userSession))

    localStorage.setItem('registrationId', JSON.stringify(data.data.wceiLogin.registration_id))

    localStorage.setItem('user', JSON.stringify({
      id: data.data.wceiLogin.customer.id,
      firstname: data.data.wceiLogin.customer.first_name,
      lastname: data.data.wceiLogin.customer.last_name,
      incompleteRegistrationCount: data.data.wceiLogin.incomplete_registration_count,
      rlpDashboardToken: data.data.wceiLogin.rlp_dashboard_token,
      rlpCertificationToken: data.data.wceiLogin.rlp_certification_token,
    }))
  }
}

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const login = async (payload: { email: string, password: string }): Promise<void> => {
  const { data }: AxiosResponse<LoginResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Store: getStoreName(),
    },
    data: {
      query: loginMutation,
      variables: {
        email: payload.email,
        password: payload.password,
      },
    },
  })

  return processLoginResponse(data)
}
